import { Account, getAccount } from '../repositories/accountRepository'

export default function getAccountProperties(): Account {
  return getAccount()
}
